import React from 'react';
import { MarqueeContainer } from './styled';

function MarqueeStrip(props) {
  const { lactoMama } = props;
  const { tabThemeSecondaryColor } = props;
  const { tabThemeColor } = props;
  return (
    <MarqueeContainer lactoMama={lactoMama} tabThemeSecondaryColor={tabThemeSecondaryColor} tabThemeColor={tabThemeColor}>
      <div className="marquee">
        <div className="marquee-content">
          <span>Increases Breast Milk Quantity</span>
          <span className="dotSeperator">.</span>
          <span>Improves Immunity</span>
          <span className="dotSeperator">.</span>
          <span>Magic of Shatavari & Moringa</span>
          <span className="dotSeperator">.</span>
          <span>95% of Lactomama users benefited</span>
          <span className="dotSeperator">.</span>
          <span>
            This changing weather, protect your family with big discounts!
          </span>
          <span className="dotSeperator">.</span>
          <span>Increases Breast Milk Quantity</span>
        </div>
      </div>
    </MarqueeContainer>
  );
}

export default MarqueeStrip;
